const updateItems = [
  {
    id: 1,
    time: '10分钟前',
    title: '某知名导演被曝片场辱骂演员，多段录音流出',
    source: '51黑料网站',
    type: 'new',
  },
  {
    id: 2,
    time: '28分钟前',
    title: '网红带货数据造假产业链曝光，涉及多位千万级博主',
    source: '91黑料网站',
    type: 'new',
  },
  {
    id: 3,
    time: '1小时前',
    title: '某女星离婚协议细节遭泄露，财产分割数额惊人',
    source: '吃瓜黑料网站',
    type: 'hot',
  },
  {
    id: 4,
    time: '2小时前',
    title: '选秀节目制作人私下收受学员贿赂录音曝光',
    source: '51黑料网站',
    type: 'hot',
  },
  {
    id: 5,
    time: '3小时前',
    title: '某顶流男星夜会神秘女子新进展：女方身份被扒',
    source: '91黑料网站',
    type: 'update',
  },
  {
    id: 6,
    time: '4小时前',
    title: '短视频平台算法黑箱被前员工曝光内部文档',
    source: '吃瓜黑料网站',
    type: 'update',
  },
  {
    id: 7,
    time: '5小时前',
    title: '网红翻车事件新后续：品牌方集体解约索赔',
    source: '51黑料网站',
    type: 'update',
  },
  {
    id: 8,
    time: '6小时前',
    title: '娱乐圈资本对赌协议再曝新细节涉及多家公司',
    source: '91黑料网站',
    type: 'update',
  },
];

export default function UpdatesSection() {
  const getTypeStyle = (type: string) => {
    if (type === 'new') return 'bg-primary-500 text-white';
    if (type === 'hot') return 'bg-accent-500 text-white';
    return 'bg-secondary-500 text-white';
  };

  const getTypeLabel = (type: string) => {
    if (type === 'new') return '新';
    if (type === 'hot') return '热';
    return '更';
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            实时更新，分秒不落的黑料动态时间线
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updateItems.map((item) => (
              <div key={item.id} className="relative mb-6 last:mb-0 group cursor-pointer">
                <span
                  className={`absolute -left-[41px] top-0 w-5 h-5 flex items-center justify-center rounded-full text-[10px] font-bold ${getTypeStyle(item.type)}`}
                >
                  {getTypeLabel(item.type)}
                </span>
                <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300">
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.time}</span>
                    <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{item.source}</span>
                  </div>
                  <h3 className="mt-2 text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}